// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {postOption} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateOptionCodes} from './option-codes';

const resetOptionToAdd = pin =>

    dispatch => {

        dispatch({
            pin,
            type: actions.RESET_PRODUCT_DETAILS_OPTION_TO_ADD
        });

    };

export const createOption = (pin, option) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postOption(pin, option);

            successAlertBar(translate('OPTION_CODE_CREATED_SUCCESSFULLY'));

            resetOptionToAdd(pin)(dispatch);
            updateOptionCodes(pin)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const updateOptionToAdd = (property, value) =>

    dispatch => {

        dispatch({
            property,
            type: actions.UPDATE_PRODUCT_DETAILS_OPTION_TO_ADD,
            value
        });

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/option-to-add.js